import * as React from 'react';
import { Pagination } from 'react-bootstrap';
import { wrap } from '../../lib/wrappers';
import { makePageIndices } from '../../lib/pagination';

interface Props {
  totalPages: number;
  maxPagesToShow?: number;
  currentPage: number;
  onSelect?: (pageIndex: number) => void;
}

const Paginator = ({
  totalPages,
  maxPagesToShow = 5,
  currentPage,
  onSelect
}: Props) => (
  <Pagination>
    <Pagination.First
      onClick={() => onSelect(1)}
      disabled={currentPage === 1}
    />
    <Pagination.Prev
      onClick={() => onSelect(currentPage - 1)}
      disabled={currentPage === 1}
    />
    {makePageIndices({ totalPages, maxPagesToShow, currentPage }).map((itemIndex) => (
      <Pagination.Item
        key={itemIndex}
        onClick={() => onSelect(itemIndex)}
        active={currentPage === itemIndex}
      >{itemIndex}</Pagination.Item>
    ))}
    <Pagination.Next
      onClick={() => onSelect(currentPage + 1)}
      disabled={currentPage === totalPages}
    />
    <Pagination.Last
      onClick={() => onSelect(totalPages)}
      disabled={currentPage === totalPages}
    />
  </Pagination>
);

export default wrap(
  Paginator
);
